// extracted by mini-css-extract-plugin
export default {"content":"Jtz0lXQOOqXTGw3k1oTm"};